import { Component, ChangeDetectionStrategy, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { RegisterUserFormService } from 'src/app/pages/register-user/services';
import { GeolocationRequestService } from '../../services';

@Component({
  selector: 'app-geolocation-request',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './geolocation-request.component.html',
  styleUrls: ['./geolocation-request.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GeolocationRequestComponent {
  private _registerUserFormService = inject(RegisterUserFormService);
  private _geolocationRequestService = inject(GeolocationRequestService);

  protected isGeolocationView = this._geolocationRequestService.isGeolocationView;
  
  protected handleRequestGeolocation(value: boolean) {
    this._requestGeolocationPermission(value);
    this._geolocationRequestService.setIsGeolocationView(false);
  }

  private _requestGeolocationPermission(value: boolean) {
    if (!navigator.geolocation) {
      console.warn('Geolocation is not supported by this browser.');
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        console.log('User allowed geolocation:', position);
        this._registerUserFormService.setGeoLocation(value);
      },
      (error) => {
        console.warn('User denied geolocation or error occurred:', error);
        if (error.code === error.PERMISSION_DENIED) {
          this._registerUserFormService.setGeoLocation(value);
        }
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      }
    );
  }
}
